export enum PortalsStatePredicate {
  AND = 'AND',
  OR = 'OR'
}
